module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chaptertitle"
  }, [_vm._v("Table of Contents")]), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/titlepage",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('a', {
    attrs: {
      "href": "#/toc"
    }
  }, [_vm._v("Table of Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('a', {
    attrs: {
      "href": "#/front01"
    }
  }, [_vm._v("Copyright")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('a', {
    attrs: {
      "href": "#/front02"
    }
  }, [_vm._v("Foreword")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('a', {
    attrs: {
      "href": "#/front03"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('a', {
    attrs: {
      "href": "#/c01"
    }
  }, [_vm._v("CHARLES BAXTER\n  Charity")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('a', {
    attrs: {
      "href": "#/c02"
    }
  }, [_vm._v("ANN BEATTIE\n  The Indian Uprising")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("T. C. BOYLE\n  The Night of the Satellite")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PETER CAMERON\n  After the Flood")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("NICOLE CULLEN\n  Long Tom Lookout")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CRAIG DAVIDSON\n  Medium Tough")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JOSHUA FERRIS\n  The Breeze")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("NELL FREUDENBERGER\n  Hover")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DAVID GATES\n  A Hand Reached Down to Guide Me")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("LAUREN GROFF\n  At the Round Earth’s Imagined Corners")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("RUTH PRAWER JHABVALA\n  The Judge’s Will")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("O. A. LINDSEY\n  Evie M.")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("WILL MACKIN\n  Kattekoppen")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BRENDAN MATHEWS\n  This Is Not a Love Song")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MOLLY McNETT\n  La Pulchra Nota")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BENJAMIN NUGENT\n  God")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JOYCE CAROL OATES\n  Mastiff")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("STEPHEN O’CONNOR\n  Next to Nothing")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("KAREN RUSSELL\n  Madame Bovary’s Greyhound")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("LAURA VAN DEN BERG\n  Antarctica")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/back01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Contributors’ Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/back02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Other Distinguished Stories of 2013")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/back03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Editorial Addresses of American and Canadian Magazines Publishing Short Stories")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/back04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Read More from The Best American Series®")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/back05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Editors")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d3bbc574","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/toc.vue
// module id = 60
// module chunks = 0